import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

// import { getSingleCategories, updateSingleCategories } from "../../assets/api/super-admin"
import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getSingleCategory } from "../../api/categories"
import Loading from "../../components/loading/loading"


const ViewCategory = () => {

    const { Query, Mutate } = useRequestProcessor();

    const { category_id } = useParams()



    const { data: fetchedData, isLoading, isError } = Query(
        ['getSingleCategory', category_id],
        () => getSingleCategory(category_id)
    );

    const [name, setName] = useState("")
    const [category, setCategory] = useState("")

    function setData(data) {
        setName(data?.title)
        setCategory(data?.type)
    }


    useEffect(() => {
        setData(fetchedData?.data)
    }, [fetchedData])




    // add default from api
    return (
        <Layout >
            {!isLoading &&
                <MainPageLayout backButton sectionTitle={"مشخصات دسته بندی " + name + " :"} title={"مشخصات دسته بندی"} >
                    <div className="flex">

                        <div className="flex flex-col w-full" >
                            <div className='flex flex-col my-4'>
                                <div className='flex flex-col my-3'>
                                    <p className='pr-3 pb-1'>نام دسته بندی :</p>
                                    <input type="text" value={name} onChange={(e) => { }} className='!w-full form-input' placeholder='نام دسته بندی' />
                                </div>
                            </div>
                            <div className="flex flex-col my-3">
                                <p className='pr-3 pb-1'>نوع دسته بندی :</p>
                                <select value={category} onChange={e => { }} disabled className="!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    <option selected disabled hidden>انتخاب نوع دسته</option>
                                    <option value={"blog"} >بلاگ</option>
                                    <option value={"workshop"} >ورک شاپ</option>
                                </select>
                            </div>
                        </div>

                        <div className="flex flex-col w-full mt-7 pr-4">
                            {
                                fetchedData.data?.parent &&
                                <div className="flex flex-col mb-2 w-full">
                                    <h2 className="text-lg">مشخصات دسته بندی اصلی :</h2>
                                    <div className="flex flex-col py-2">
                                        <p>آیدی سازنده :  {fetchedData.data?.parent?.id}</p>
                                        <p>نام سازنده :  {fetchedData.data?.parent?.creator?.name ?? "" + " " + fetchedData?.data?.parent?.creator?.lastname ?? ""}</p>
                                        <p>شماره سازنده :  {fetchedData.data?.parent?.creator?.phone}</p>
                                        <p>عنوان دسته بندی اصلی :  {fetchedData.data?.parent?.title}</p>
                                        <p>دسته بندی سازنده :  {fetchedData.data?.parent?.type === "blog" ? "بلاگ" : "ورک شاپ"}</p>
                                    </div>
                                </div>

                            }
                            {
                                fetchedData.data?.child?.length !== 0  &&
                                <div className="flex flex-col mb-2 w-full">
                                    <h2 className="text-lg">مشخصات دسته بندی زیرشاخه :</h2>
                                    <div className="grid grid-cols-4 py-2">
                                        {
                                            fetchedData.data?.child?.map(el => (
                                                <p>{el.id}. - {el.title}</p>
                                            ))
                                        }
                                    </div>
                                </div>
                            }

                        </div>
                    </div>

                </MainPageLayout>
            }
            {
                isLoading && <Loading />
            }
        </Layout>
    )
}

export default ViewCategory